<template>
  <layout-no-container v-bind="$attrs">
    <div class="">
      <div
        class="relative mini-hero center flex flex-middle flex-center padding-2xl-vertical box-shadow-2 overflow-hidden"
        style="min-height: 120px; border-bottom: 1px solid var(--c-gray-1)">
        <div
          v-rellax="{ speed: -2.5 }"
          :style="{ 'background-image': `url('${getDynamicAssetUrl(bgSrc)}')` }"
          class="bg absolute-cover bg-cover z-level-1"></div>
        <div class="shader-4 absolute-cover z-level-2"></div>
        <div class="container container-l margin-auto-horizontal z-level-3">
          <block v-rellax="{ speed: -1.5 }">
            <fancy-title
              theme="bg"
              class="flex-start margin-remove"
              align="center"
              :h1="true"
              :title="title"
              :title-params="titleParams"
              :content="subTitle"></fancy-title>
          </block>
        </div>
      </div>
      <vendor-floating-nav v-bind="navProps"></vendor-floating-nav>

      <main class="container container-l margin-max-vertical" :class="containerClass">
        <slot></slot>
      </main>
    </div>
  </layout-no-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      Boolean,
      default: false,
    },
    titleParams: {
      type: Object,
      default: {},
    },
    subTitle: {
      type: String,
      Boolean,
      default: false,
    },
    bgSrc: {
      type: String,
      default: "images/default-layout/bg1.jpg",
    },
    bgUrl: {
      type: [String, Boolean],
      default: false,
    },
    containerClass: {
      type: String,
      default: "",
    },
    navProps: {
      type: Object,
      default: {},
    }
  },
  data() {
    return {
      // showHeader: this.$store.getters['talron/showHeader'],
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.mini-hero {
}
</style>
